import React, { PureComponent } from 'react';
import PrimaryFilter from './PrimaryFilter';
import SecondaryFilter from './SecondaryFilter';
import FilterDtm from './FilterDtm';
// import SortFilter from './SortFilter';
import './Filters.scss';
import { removeParameterFromUrl } from '../../../utils/helper';
import localStorageHelper from '../../../utils/localStorageHelper';
// import sessionStorageHelper from '../../../utils/sessionStorageHelper';

class Filters extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showMore: false,
      lastFilterBg: false,
      // order: 'desc',
      userFrameSize: '',
    };
    this.selectedFilter = [];
  }
  componentDidMount() {
    const { categoryType } = this.props;
    const prefSize = localStorageHelper.getItem('prefSize');
    if (prefSize && categoryType) {
      const userFrameSize = prefSize[categoryType.toLowerCase()];
      (() => this.setState({ userFrameSize }))();
    }
  }
  componentDidUpdate(prevProps) {
    const { location, FilterDataObj, categoryType, breadcrumb } = this.props;
    if (prevProps.location.pathname !== location.pathname && Object.keys(prevProps.FilterDataObj)) {
      Object.keys(prevProps.FilterDataObj).forEach(oldFilterKey => {
        if (oldFilterKey) FilterDtm.updateFilterDtm(oldFilterKey);
      });
    }
    // refresh with filters
    if (
      Object.keys(FilterDataObj).length > 0 &&
      categoryType &&
      Object.keys(prevProps.FilterDataObj).length !== Object.keys(FilterDataObj).length
    ) {
      let finalFilterVal = '';
      let innerValue = '';
      let filterVal = '';
      const obj = {};
      let keyValue = [];
      let trimKey = '';
      Object.keys(FilterDataObj).forEach(filterKey => {
        innerValue = '';
        filterVal = '';
        keyValue = [];
        FilterDataObj[filterKey].forEach((filter, index) => {
          if (index === FilterDataObj[filterKey].length - 1) {
            innerValue = `${innerValue}${filter.childname.toLowerCase()}|`;
          } else {
            innerValue = `${innerValue}${filter.childname.toLowerCase()},`;
          }
          filterVal = innerValue;
          keyValue.push(filter.childname);
          if (filterKey?.indexOf('_id') !== -1) {
            trimKey = filterKey.replace(/_/g, ' ').replace(' id', '');
          } else if (filterKey?.indexOf('lenskart') !== -1) {
            trimKey = filterKey.replace('lenskart_', '');
          }
          filterVal = `${trimKey}:${filterVal}`;
        });
        trimKey = trimKey.replace(' ', '');
        if (trimKey?.indexOf('price') !== -1) {
          trimKey = trimKey.concat('range');
        }
        obj[trimKey] = [keyValue];
        finalFilterVal += filterVal;
      });
      finalFilterVal = finalFilterVal.slice(0, -1);
      if (breadcrumb) {
        const dtmObject = {
          obj,
          sort: this.props.order,
          filter: finalFilterVal,
          login: prevProps.login,
          userInfo: prevProps.userInfo,
        };
        FilterDtm.updateCategoryDtm({ breadcrumb, categoryType }, dtmObject);
      }
    }
    // When no filters applied / Reload case without filters / Category update fix
    if (
      location.hash === '' &&
      Object.keys(FilterDataObj).length === 0 &&
      categoryType &&
      Object.keys(prevProps.FilterDataObj).length !== Object.keys(FilterDataObj).length
    ) {
      if (breadcrumb) {
        const dtmObject = {
          obj: {},
          sort: this.props.order,
          filter: '',
          login: prevProps.login,
          userInfo: prevProps.userInfo,
        };
        FilterDtm.updateCategoryDtm({ breadcrumb, categoryType }, dtmObject, this.dtmStateFound);
      }
    }

    const pageInfo = `page: ${document.location.hostname}${document.location.pathname};filter: ${this.props.location.hash}`;
    if (this.props.location.hash !== '') {
      _gaq.push(
        ['_trackEvent', 'Category Page', 'Filter Usage', pageInfo],
        ['ninja._trackEvent', 'Category Page', 'Filter Usage', pageInfo]
      );
    }
  }

  handleFilterState(filterObj) {
    const { categoryActions } = this.props;
    categoryActions.addFilterData(filterObj);
    categoryActions.handleFilterFunc(this.handleFilter);
  }

  loadCatData(data) {
    const { categoryActions, location, categoryId } = this.props;
    let mystring = '';
    const incLimit = Object.keys(data).length - 1;
    Object.keys(data).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key;
      data[key].forEach((val, index) => {
        if (index === data[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (parentIndex === incLimit) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    let loc = '';
    if (location.hash.includes('dir')) {
      if (location.hash.split('dir')[0].length > 0 && location.hash.split('dir')[0].length !== 1) {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir') - 1,
          location.hash.lastIndexOf('true') + 4
        );
      } else {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir'),
          location.hash.lastIndexOf('true') + 4
        );
      }
    }
    // let searchQuery = '';
    // if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
    //     searchQuery = `&${readQueryParam('q', `${location.search}`, true)}&`;
    // }
    // history.replaceState(`${location.pathname}${location.hash}`, null, location.pathname + `${searchQuery}#${location.hash}`);
    categoryActions.loadCatAndFilterData(categoryId, mystring + loc, 0);
  }

  handleFilter = (name, array, TempData, apiTempData = {}) => {
    const { categoryActions, FilterDataObj } = this.props;
    const filterMater = FilterDataObj;
    if (Object.keys(filterMater).length) {
      if (name in filterMater) {
        delete filterMater[name];
      }
    }
    let localObj = {};
    if (Object.keys(filterMater).length !== 0) {
      localObj = filterMater;
    } else if (TempData) {
      localObj = TempData;
      if (Object.keys(localObj).length !== 0) {
        if (name in localObj) {
          delete localObj[name];
        }
      }
    }
    let apilocalObj = {};
    if (Object.keys(apiTempData).length !== 0) {
      apilocalObj = apiTempData;
    } else {
      Object.keys(localObj).forEach(data => {
        apilocalObj[`filter_${data}`] = localObj[data];
      });
    }
    if (apiTempData || Object.keys(apilocalObj).length !== 0) {
      if (Object.keys(apilocalObj).length === 0) {
        apilocalObj = apiTempData;
      }
      if (name in apilocalObj) {
        delete apilocalObj[name];
      }
    }
    let mystring = '';
    if (name in localObj && Object.keys(localObj).length !== 0) {
      localObj[name].push(array[0]);
    } else {
      localObj[name] = array;
    }
    apilocalObj[`filter_${name}`] = array;
    if (localObj[name].length === 0) {
      delete localObj[name];
    }
    if (apilocalObj[`filter_${name}`].length === 0) {
      delete apilocalObj[`filter_${name}`];
    }
    this.handleFilterState(localObj);
    const incLimit = Object.keys(localObj).length;
    // Loop to make the url after addition/removal of the filters
    Object.keys(localObj).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key.replace(/\s+/, '_');
      localObj[key].forEach((val, index) => {
        if (index === localObj[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (typeof localObj[key][0] === 'undefined') {
        mystring += '';
      } else if (parentIndex === incLimit - 1) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    if (this.props.location.hash.includes('dir') && mystring.length) {
      const loc = this.props.location.hash.slice(
        this.props.location.hash.lastIndexOf('dir'),
        this.props.location.hash.lastIndexOf('true') + 4
      );
      let temp = loc;
      if (loc.includes('#')) {
        temp = loc.split('#')[1];
      }
      mystring = `${mystring}&${temp}`;
    } else if (this.props.location.hash.includes('dir') && !mystring.length) {
      const loc = this.props.location.hash.slice(
        this.props.location.hash.lastIndexOf('dir'),
        this.props.location.hash.lastIndexOf('true') + 4
      );
      let temp = loc;
      if (loc.includes('#')) {
        temp = loc.split('#')[1];
      }
      mystring += temp;
    }
    if (window.location.href?.indexOf('page=') !== -1) {
      const removePageParam = removeParameterFromUrl(window.location.href, 'page');
      history.pushState(window.location.href, null, `${removePageParam}#${mystring}`);
    } else {
      history.pushState('', '', `#${mystring}`);
    }
    const modTemp = {};
    modTemp.location = this.props.location;
    modTemp.location.hash = mystring;
    modTemp.counter = 1;
    categoryActions.modifyData(modTemp);
    this.loadCatData(apilocalObj);
    categoryActions.handleFilterFunc(this.handleFilter);
  };

  modifySelectedFilterList = (childname, childid, currentFilterData) => {
    const { filterArray, addingGaDataInFilterArray } = this.props;
    let childData = [];
    const { FilterDataObj } = this.props;
    childData = FilterDataObj[currentFilterData.id] || [];
    const index = childData.findIndex(item => {
      return JSON.stringify(item) === JSON.stringify({ childid, childname });
    });
    if (index > -1) {
      childData.splice(index, 1);
    } else {
      childData.push({ childid, childname });
    }
    const itemIndex = this.selectedFilter?.indexOf(childname);
    if (itemIndex > -1) {
      this.selectedFilter.splice(itemIndex, 1);
    } else {
      this.selectedFilter.push(childname);
    }
    const allFilter = [];
    const filter = {};
    filter[currentFilterData?.id] = childname;
    allFilter.push(filter);
    let isContainFilterData = false;
    if (filterArray.length > 0) {
      isContainFilterData = filterArray.some(item => item[currentFilterData?.id] === childname);
    }
    if (allFilter.length > 0 && !isContainFilterData) {
      const totalFilter = allFilter.length;
      const appliedFilterString = Object.assign({}, ...allFilter);
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.filter.appliedFilter(appliedFilterString, totalFilter);
    }
    addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname);
    // Update DTM value when filter removed
    if (childData.length === 0) {
      FilterDtm.updateFilterDtm(currentFilterData.id);
    }
    this.handleFilter(currentFilterData.id, childData);
  };

  render() {
    const { filterData, /* order, */ dataLocale } = this.props;
    const { userFrameSize } = this.state;
    const { SHOP_BY, LESS_FILTERS, MORE_FILTERS } = dataLocale;
    let FilterResult;
    if (filterData && typeof filterData.result !== 'undefined') {
      FilterResult = filterData.result.filters;
      const frameSizeFilterIndex = FilterResult.findIndex(filter => filter.id === 'frame_size_id');
      if (userFrameSize && frameSizeFilterIndex > 2) {
        FilterResult.splice(2, 0, FilterResult[frameSizeFilterIndex]);
        FilterResult.splice(frameSizeFilterIndex + 1, 1);
      }
    }
    const secondaryFilterItems = 3;

    return (
      <div className="vertical-filter">
        <div className="container-fluid no-padding filter-master">
          {FilterResult && (
            <div
              className="col-sm-12 no-padding"
              style={{ width: FilterResult.length > 0 ? 'auto' : '100vw' }}
            >
              <div className="shop-by hidden-sm">{SHOP_BY}</div>
              {FilterResult.length > 0 &&
                FilterResult.map((filter, index) => {
                  if (index < secondaryFilterItems && filter.options.length > 0) {
                    return (
                      <PrimaryFilter
                        key={index}
                        ref={filter.id}
                        dataLocale={dataLocale}
                        {...this.props}
                        currentFilterData={filter}
                        filterData={filter}
                        modifySelectedFilterList={this.modifySelectedFilterList}
                        userFrameSize={userFrameSize}
                      />
                    );
                  }
                  return <span key={index}></span>;
                })}
              <div className="lastfilterdata col-sm-9 col-sm-offset-1 no-padding">
                {FilterResult.length > 3 &&
                  FilterResult.map((filter, key) => {
                    if (key > 2 && filter.options.length > 0) {
                      return (
                        <div key={key} className="col-sm-3">
                          <SecondaryFilter
                            key={filter.id}
                            ref={filter.id}
                            currentFilterData={filter}
                            dataLocale={dataLocale}
                            {...this.props}
                            filterData={filter}
                            modifySelectedFilterList={this.modifySelectedFilterList}
                            userFrameSize={userFrameSize}
                          />
                        </div>
                      );
                    }
                    return <span key={filter.id}></span>;
                  })}
              </div>
              <div
                className={
                  !this.state.lastFilterBg
                    ? 'lastfilter pull-left pos-abs-filter'
                    : 'lastfilter pull-left '
                }
                onClick={() => {
                  if (FilterResult.length) {
                    FilterResult.forEach((filter, index) => {
                      if (index < secondaryFilterItems && filter.options.length > 0) {
                        if (this.refs[filter.id] && this.refs[filter.id].state) {
                          this.refs[filter.id].state.showUL = false;
                          this.refs[filter.id].state.greyBg = false;
                        }
                      }
                    });
                  }
                  this.setState({
                    showMore: !this.state.showMore,
                    lastFilterBg: !this.state.lastFilterBg,
                  });
                }}
              >
                {FilterResult.length > 5 && (
                  <div className="dropdown">
                    <div
                      aria-expanded="true"
                      aria-haspopup="true"
                      className="filterbtn dropdown-toggle"
                      type="button"
                    >
                      {this.state.lastFilterBg ? (
                        <span>
                          <span className="margin-r5">{LESS_FILTERS}</span>
                          <span className="glyphicon glyphicon-chevron-up"></span>
                        </span>
                      ) : (
                        <span>
                          <span className="margin-r5">{MORE_FILTERS}</span>
                          <span className="glyphicon glyphicon-chevron-down"></span>
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {/* <SortFilter {...this.props} order={this.state.order} sortFilterValue={order} /> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Filters;
